import { __rest } from 'tslib';
import { t } from './i18n.es.js';
import React from 'react';
import { styled, Currency, ComboImage, LazyImage, Row, Col, FormInput } from '@teko/ui';
import { space } from 'styled-system';
import { Body } from '@teko/ds-foundation';
import { G as Gift } from './Gift-48d89956.js';
import { C as CustomLink } from './CustomLink-b9e0bc02.js';
import { Formik } from 'formik';

const WrapperInfo = styled.div(space);
const StyledCurrency = styled(Currency) `
  font-weight: bold;
`;
const StyledGift = styled(Gift) `
  margin: 0.5rem 0;
`;
const GiftBlock = styled.div `
  margin-left: 3rem;
`;
const Wrapper$1 = styled.div `
  display: flex;
`;
const Right = styled.div `
  flex: 1;
  margin-left: 1rem;
`;
const Quantity = styled.div `
  color: #848788;
  font-size: 0.75rem;
`;
const ListedPrice = styled(Currency)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? 'line-through' : 'none'};
  color: ${theme.colors.gray130};
  font-size: ${size === 'md' ? '0.75rem' : '1.25rem'};
  margin-left: ${horizontal ? '6px' : ''};
`);
const DiscountWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
`;
const ProductCheckoutInfo = (_a) => {
    var { imageUrl, name, quantity, price, unitPrice, gifts, targetPath, disableProductPromo, consultationServiceFee = 0, comboName, comboImages = [] } = _a, props = __rest(_a, ["imageUrl", "name", "quantity", "price", "unitPrice", "gifts", "targetPath", "disableProductPromo", "consultationServiceFee", "comboName", "comboImages"]);
    return (React.createElement(WrapperInfo, Object.assign({}, props),
        React.createElement(Wrapper$1, null,
            React.createElement("div", null, comboImages.length > 0 ? (React.createElement(ComboImage, { images: comboImages })) : (React.createElement(LazyImage, { height: 80, width: 80, borderRadius: 4, contain: true, border: true, src: imageUrl, alt: "product" }))),
            React.createElement(Right, null,
                React.createElement(CustomLink, { targetPath: targetPath, targetType: "_blank", passHref: true },
                    React.createElement(Body, { level: 1, color: "textPrimary", weight: "regular", line: 2, hoverColor: "primary500" }, comboName ? comboName : name)),
                React.createElement(Quantity, null,
                    t('Số lượng'),
                    " ",
                    quantity),
                React.createElement(StyledCurrency, { value: price }),
                unitPrice && unitPrice !== price - consultationServiceFee && (React.createElement(DiscountWrapper, null,
                    React.createElement(ListedPrice, { horizontal: false, size: "md", value: unitPrice, lineThrough: true }))))),
        React.createElement(Wrapper$1, null, !!gifts.length && (React.createElement(GiftBlock, null, gifts.map((gift, index) => (React.createElement(StyledGift, { key: index, image: {
                src: gift.imageUrl,
            }, text: gift.name, disableProductPromo: disableProductPromo && !gift.isDefault }))))))));
};

const Input = styled.input `
  height: 40px;
  border: solid 1px #e0e0e0;
  border-radius: 4px;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 4px;
  width: 100%;
  :focus {
    outline: 0;
  }
`;
const Wrapper = styled.div `
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1rem;
`;
const Require = styled.span `
  color: red;
`;
const InvoiceInfo = (_a) => {
    var { invoiceInfo, setInvoiceInfo, readOnly } = _a, props = __rest(_a, ["invoiceInfo", "setInvoiceInfo", "readOnly"]);
    const defaultInvoice = Object.assign({
        name: '',
        email: '',
        taxCode: '',
        address: '',
    }, invoiceInfo);
    return (React.createElement(Formik, { initialValues: {
            name: defaultInvoice.name,
            email: defaultInvoice.email,
            taxCode: defaultInvoice.taxCode,
            address: defaultInvoice.address,
        }, onSubmit: () => { }, validate: (values) => {
            const errors = {};
            if (!values.name) {
                errors.name = t('Trường bắt buộc');
            }
            if (!values.taxCode) {
                errors.taxCode = t('Trường bắt buộc');
            }
            if (!values.email) {
                errors.email = t('Trường bắt buộc');
            }
            else if (values.email &&
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = t('Email không đúng định dạng');
            }
            if (!values.address) {
                errors.address = t('Trường bắt buộc');
            }
            return errors;
        } }, ({ values, touched, errors, handleSubmit, handleBlur, handleChange, }) => (React.createElement("form", { onSubmit: handleSubmit },
        React.createElement(Wrapper, Object.assign({}, props),
            React.createElement(Row, null,
                React.createElement(Col, { col: 6 },
                    t('Tên doanh nghiệp'),
                    React.createElement(Require, null, "*"),
                    React.createElement(FormInput, { name: "name", placeholder: t('Nhập tên doanh nghiệp'), onChange: (event) => {
                            handleChange(event);
                            setInvoiceInfo(Object.assign(Object.assign({}, invoiceInfo), { name: event.target.value }));
                        }, onBlur: handleBlur, disabled: readOnly, value: values.name, variant: touched.name && errors.name ? 'invalid' : undefined, feedback: touched.name && errors.name })),
                React.createElement(Col, { col: 6 },
                    t('Mã số thuế'),
                    React.createElement(Require, null, "*"),
                    React.createElement(FormInput, { name: "taxCode", placeholder: t('Nhập mã số thuế'), onChange: (event) => {
                            handleChange(event);
                            setInvoiceInfo(Object.assign(Object.assign({}, invoiceInfo), { taxCode: event.target.value }));
                        }, onBlur: handleBlur, disabled: readOnly, value: values.taxCode, variant: touched.taxCode && errors.taxCode ? 'invalid' : undefined, feedback: touched.taxCode && errors.taxCode }))),
            React.createElement(Row, { marginTop: 3 },
                React.createElement(Col, { col: 6 },
                    t('Email nhận hóa đơn'),
                    React.createElement(Require, null, "*"),
                    React.createElement(FormInput, { name: "email", type: "email", disabled: readOnly, placeholder: t('Nhập email nhận hóa đơn'), onChange: (event) => {
                            handleChange(event);
                            setInvoiceInfo(Object.assign(Object.assign({}, invoiceInfo), { email: event.target.value }));
                        }, onBlur: handleBlur, value: values.email, variant: touched.email && errors.email ? 'invalid' : undefined, feedback: touched.email && errors.email })),
                React.createElement(Col, { col: 6 },
                    t('Địa chỉ trên hóa đơn'),
                    React.createElement(Require, null, "*"),
                    React.createElement(FormInput, { name: "address", placeholder: t('Nhập địa chỉ trên hóa đơn'), disabled: readOnly, onChange: (event) => {
                            handleChange(event);
                            setInvoiceInfo(Object.assign(Object.assign({}, invoiceInfo), { address: event.target.value }));
                        }, onBlur: handleBlur, value: values.address, variant: touched.address && errors.address ? 'invalid' : undefined, feedback: touched.address && errors.address }))))))));
};

export { Input as I, ProductCheckoutInfo as P, InvoiceInfo as a };
